<!--  -->
<template>
  <div class="order-item">
    <div class="shop-select-area fl-align-center primary-text">
      <span>{{ info.entityName }} {{ info.entityEnName }}</span>
    </div>
    <div v-for="item in info.goodsInfoList" :key="item.skuId" class="item-container fl-align-center">
      <div class="good-item fl-align-center">
        <img class="cover-img" :src="item.coverImage" />
        <div class="good-detail">
          <div class="good-chname sl-ellipsis primary-text">{{ item.spuName }}</div>
          <div class="good-enname sl-ellipsis primary-text">{{ item.spuNameEn }}</div>
          <div class="good-spec mar-t-18">{{ item.spec || "单规格" }}</div>
        </div>
        <div class="good-price-count">
          <div>
            <template v-if="item.payType == 0">
              <span class="pay-symbol">￥</span>
              <span class="good-pay">{{ item.price }}</span>
            </template>
            <template v-if="item.payType == 1">
              <span class="good-pay">{{ item.integral }}</span>
              <span class="pay-symbol">积分</span>
            </template>
            <template v-if="item.payType == 2">
              <span class="pay-symbol">￥</span>
              <span class="good-pay">{{ item.price }}</span>
              <span class="good-pay">+{{ item.integral }}</span>
              <span class="pay-symbol">积分</span>
            </template>
            <span class="good-count">×{{ item.qty }}</span>
          </div>
          <div class="mar-t-18" v-if="item.decrAmount">
            商品优惠：￥{{item.decrAmount}}
          </div>
        </div>
        <div class="good-distribution">
          <template v-if="takeType == 1">物流配送 Logistics and distribution</template>
          <template v-if="takeType == 2">自提 Self Pickup</template>
        </div>
      </div>
    </div>
    <div class="take-address fl-align-center" v-if="takeType == 2">
      <span>提货地址 Pick-up address</span>
      <span class="take-position"
        >{{ info.takeAddress || "--" }} {{ info.takeConcat || "--" }} {{ info.takeConcat || "--" }}</span
      >
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    info: {
      type: Object,
      default: () => {},
    },
    takeType: {
      type: [String, Number],
      default: 0, //提货方式 1 物流 2 自提 3 物流 + 自提
    },
  },
  data() {
    return {
      addressList: []
    };
  },
  computed: {},
  mounted() {},
  methods: {
    //获取收货地址
    async getAddressList() {
      const params = {
        page: 1,
        pageSize: 100,
      };
      try {
        let {
          data: { list, total },
        } = await this.$api.getAddressList(params);
        this.addressList = list || [];
      } catch (error) {
        console.log(error);
      }
    },

    handleExpand() {
      this.isExpand = !this.isExpand;
    },
  },
  watch: {},
};
</script>
<style lang="scss" scoped>
.order-item {
  .shop-select-area {
    width: 100%;
    height: 40px;
    background: #ffffff;
    border: 1px solid #f0f0f0;
    padding-left: 30px;
    box-sizing: border-box;
  }
  .item-container {
    .good-item {
      height: 148px;
      width: 100%;
      background: #fcfcfc;
      border: 1px solid #f0f0f0;
      border-bottom: 0;
      padding-left: 30px;
      box-sizing: border-box;
      .cover-img {
        width: 88px;
        height: 88px;
      }
      .good-detail {
        margin-left: 20px;
        width: 250px;
        .good-spec {
          font-size: 14px;
          color: #999999;
        }
      }
      .good-price-count {
        margin-left: 60px;
        font-size: 14px;
        font-weight: bold;
        color: #333333;
      }
      .good-distribution {
        margin-left: auto;
        margin-right: 60px;
        align-self: flex-start;
        margin-top: 37px;
      }
    }
  }
  .take-address {
    width: 100%;
    background: #fcfcfc;
    border: 1px solid #f0f0f0;
    padding-left: 30px;
    box-sizing: border-box;
    height: 74px;
    .take-position {
      margin-left: 55px;
    }
  }
}
.mar-t-18 {
  margin-top: 18px;
}
</style>
